import * as Yup from "yup";
import * as moment from "moment";
import { FORMAT } from "./dateOfBirthValidation";

export function getPostInitialValues() {

    let reqDefaultPickupDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)

    return {
        businessName: "",
        loadingReq: "",
        reqPickupQuantity: '',
        ptplusOrderReqPickupDate: reqDefaultPickupDate,
        appFromTime: "00:00",
        appToTime: "23:00",
        poNumber: "",
        comments: ''
    };
}
const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
    }
    return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };